export default (e, cb) => {
	var reader = new FileReader();
  reader.onload = function() { cb(reader.result) };
  reader.readAsDataURL(e.target.files[0]);
}